<template>
  <div v-if="loading">
    <b-row>
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-4"
        />
      </b-col>
    </b-row>
  </div>
  <div v-else class="animated fadeIn">
    <component-header
      title="Offices"
      @search-query="(val) => (filter = val)"
      :isLoading="loading"
      @reload-data="getOfficeList"
      @create-press="createOffice"
    />
    <b-card class="card-wrap" border-variant="info">
      <div>
        <b-table
          style="border-radius: 12px"
          responsive
          :fields="partnerColumns"
          :items="partners"
          :dark="dark"
          :hover="hover"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          thead-class="header"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          show-empty
          ref="partners"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="name" slot-scope="data">
            <div class="table-row">{{ data.userName }}</div>
          </template>
          <template slot="action" slot-scope="data">
            <b-button
              size="sm"
              class="button-circle mr-2"
              variant="primary"
              @click="viewOffice(data.item)"
            >
              <i class="fa fa-eye"></i>
            </b-button>
            <b-button
              size="sm"
              class="button-circle mr-2"
              style="background: #fe7b08; border: #fe7b08"
              variant="primary"
              @click="editOffice(data.item)"
            >
              <i class="fa fa-pencil edit"></i>
            </b-button>

            <b-button
              size="sm"
              class="button-circle"
              @click="deleteOffice(data.item)"
              variant="danger"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </div>
      <div style="float: right">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="partners.length"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "viewattribute",
  components: {
    ebButton,
    AtomSpinner,
    ComponentHeader,
  },
  data() {
    return {
      filter: "",
      loading: false,
      hover: true,
      currentPage: 1,
      perPage: 10,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      partner: {},
      sortBy: "createdAt",
      sortDesc: true,
      partnerColumns: [
        {
          key: "userName",
          sortable: true,
        },
        {
          key: "email",
        },
        {
          key: "phone",
        },
        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    partners() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let partnerList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          let arrayObj = {
            _id: obj._id,
            userName: obj.authentication.userName,
            email: obj.authentication.email,
            phone: obj.authentication.phone,
            ...obj,
          };
          partnerList.push(arrayObj);
        });
        return partnerList;
      } else {
        return [];
      }
    },
  },
  methods: {
    viewOffice(data) {
      this.$store.dispatch("partner/editPartnerData", data);
      this.$router.push("/office-management/view");
    },
    editOffice(data) {
      this.$store.dispatch("partner/editPartnerData", data);
      this.$router.push("/office-management/edit");
    },
    createOffice() {
      this.$router.push("/office-management/create");
    },
    async getOfficeList() {
      this.loading = true;
      await this.$store.dispatch("partner/officeList").then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
          this.loading = false;
        }
        this.loading = false;
      });
    },
    async deleteOffice(data) {
      await this.$swal({
        title: "Are you sure?",
        text: "You can't revert this action!!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("partner/deletePartner", data._id)
            .then((result) => {
              this.$toasted.success("User Deleted Successfully");
              this.getOfficeList();
            });
          this.isLoading = false;
        }
      });
    },
  },
  async mounted() {
    this.loading = true;
    let data = this.$store.getters["partner/GetPartnerList"];
    await this.getOfficeList();
    this.$store.dispatch("partner/editPartnerData", null);
    this.loading = false;
  },
};
</script>

<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
